import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { getQuizResultsReport } from "../../../../api/cp";
import Select from "react-select";
import { Checkbox, Col, ControlLabel, FormGroup, Row, Table, Button } from "react-bootstrap";
import Pagination from "../../UI/Pagination";

const participationTypeOptions = [
    { value: '', label: 'Нет' },
    { value: 'online', label: 'Онлайн' },
    { value: 'offline', label: 'Оффлайн' },
];

const getDownloadLink = (id, params) => {
    let link = `/api/cp/event/quiz/${id}/report.xlsx`;

    const queryParams = [];

    for (const param in params) {
        if (params[param]) {
            queryParams.push(`${param}=${params[param]}`)
        }
    }

    if (queryParams.length) {
        link = [link, queryParams.join('&')].join('?')
    }

    return link;
}

export default ({ id }) => {

    const [page, setPage] = useState(null);
    const [participationType, setParticipationType] = useState('');
    const [speedSort, setSpeedSort] = useState(false);
    const [loading, setLoading] = useState(true);

    const [tableData, setTableData] = useState([]);
    const [pageCount, setPageCount] = useState(1);

    const getReport = async (page) => {
        if (!id) {
            setTableData([]);
            return;
        }

        setLoading(true);

        let params = { page: page + 1 };

        if (participationType) {
            params = { ...params, participationType }
        }
        if (speedSort) {
            params = { ...params, speedSort }
        }

        try {
            const { items, pagination } = await getQuizResultsReport(id, params);
            setTableData(items);
            setPageCount(pagination?.pageCount)
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (page !== null) {
            getReport(page)
        }
    }, [page]);

    useEffect(() => {
        setPage(0);
        getReport(0);
    }, [participationType, speedSort]);

    return <div>
        <Row>
            <Col xs={12} style={{ marginBottom: '2rem' }}>
                <Button bsStyle='success' href={getDownloadLink(id, { participationType, speedSort })}>Скачать результаты</Button>
            </Col>
            <Col xs={6}>
                <FormGroup>
                    <ControlLabel>Формат участия</ControlLabel>
                    <Select
                        name="participationType"
                        options={participationTypeOptions}
                        value={participationTypeOptions.find(({ value }) => participationType === value) || participationTypeOptions[0]}
                        onChange={({ value }) => setParticipationType(value)}
                    />
                </FormGroup>
            </Col>
            <Col xs={6}>
                <FormGroup style={{ marginTop: '3.25rem' }}>
                    <Checkbox
                        checked={speedSort}
                        onChange={(e) => setSpeedSort(e.target.checked)}
                    >Сортировать по скорости завершения квиза</Checkbox>
                </FormGroup>
            </Col>
        </Row>

        {!!tableData.length ?
            <Table style={{ margin: 0 }}>
                <thead>
                    <tr>
                        <th width={360}>ФИО</th>
                        <th width={220}>Количество правильных ответов</th>
                        <th width={150}>Время завершения</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((datum, i) => <tr key={i}>
                        <td>{datum.nickname}</td>
                        <td>{datum.correctAnswers}</td>
                        <td>{moment(datum.createdAt).format('DD.MM.YY HH:mm:ss')}</td>
                    </tr>)}
                </tbody>
            </Table> : <div style={{width: '100%', padding: '2rem', textAlign: 'center', color: '#c3c3c3'}}>{!loading && 'Нет данных'}</div>
        }

        <Pagination pages={pageCount} page={page} onPage={(page) => setPage(page)} />

    </div>
}
